module.exports = __webpack_public_path__ + "static/fss-25b5f961d563b9983ae5669f9408c32f.jpg";